import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function (state = initialState.dialysisdetail, { type, payload }) {
    switch (type) {
        case types.DIALYSISDETAIL_REQUEST:
            return {
                ...initialState.dialysisdetail,
                isLoading: true,
                isStatus: 'request',
                request: payload,
                successResponse: {},
                errorResponse: {}
            };
        case types.DIALYSISDETAIL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isStatus: 'success',
                successResponse: payload,
                request: {}
            };
        case types.DIALYSISDETAIL_FAILURE:
            return {
                ...state,
                isLoading: false,
                isStatus: 'error',
                successResponse: {},
                errorResponse: payload,
                request: {}
            };
        default:
            return state;
    }
}